interface MaintenanceObjectiveProps {
  systemDisplayName: string | undefined
  actionDisplayName: string | undefined
  partDisplayName: string | undefined
  actionDescription?: string;
}

const MaintenanceObjective = ({
  systemDisplayName,
  actionDisplayName,
  partDisplayName,
  actionDescription,
}: MaintenanceObjectiveProps) => {
  return (
    <div className="flex flex-col items-start">
      <p className="font-bold text-base">
        {actionDisplayName} {partDisplayName}
        {systemDisplayName && (
          <>
            {' '}
            <span className="font-normal">em</span> {systemDisplayName}
          </>
        )}
      </p>

      {actionDescription && <p className="text-xs">{actionDescription}</p>}
    </div>
  )
}

export default MaintenanceObjective
